import { render, staticRenderFns } from "./c-back.vue?vue&type=template&id=08bb22d6&scoped=true"
import script from "./c-back.vue?vue&type=script&lang=js"
export * from "./c-back.vue?vue&type=script&lang=js"
import style0 from "./c-back.vue?vue&type=style&index=0&id=08bb22d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb22d6",
  null
  
)

export default component.exports